module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_11_2.a565551e.jpeg";